import LogRocket from 'logrocket'

import env from 'lib/config/public-env'
import createLogError from 'lib/utils/log-error'

// Just log it once
const logError = createLogError(1)

const ConsoleLogger = {
  identify(...args: any[]) {
    logError('LogRocket not enabled', ...args)
  },
  captureException(
    exception: Error | unknown,
    options?: {
      extras?: {
        [name: string]: string | number | boolean
      }
      tags?: {
        [tag: string]: string | number | boolean
      }
    }
  ) {
    console.error(exception, options) // do not rate limit this
  }
}

if (typeof window !== undefined && env.VERCEL_ENV === 'production') {
  LogRocket.init(env.LOGROCKET)
}

export default typeof window !== undefined && env.VERCEL_ENV === 'production'
  ? LogRocket
  : ConsoleLogger
